/* tslint:disable */
/* eslint-disable */

import _Vue from 'vue';
import PreviewGallery from '@/components/PreviewGallery.vue';

class PreviewGalleryPlugin {
  private component: any = null;

  install(Vue: typeof _Vue, options?: any) {
    const ComponentClass = Vue.extend(PreviewGallery);
    this.component = new ComponentClass();
    this.component.$mount();
    document.body.appendChild(this.component.$el);

    Vue.prototype.$previewGallery = {
      open: (mediumIds: number[], startId: number) => {
        return this.component.open(mediumIds, startId);
      }
    };
  }
}

declare module 'vue/types/vue' {
  interface Vue {
    $previewGallery: {
      open: (mediumIds: number[], startId: number) => Promise<void>;
    };
  }
}

export default new PreviewGalleryPlugin();
